import { createFileRoute } from '@tanstack/react-router';

type Search = {
  formId?: string;
  previewPacket?: boolean;
};

/**
 * This is a LEGACY route!
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/forms/library/packets_/$id')({
  staticData: { team: 'forms' },
  validateSearch: (search: Search): Search => {
    return {
      formId: search.formId,
      previewPacket: search.previewPacket,
    };
  },
});
